export const normalizeBrand = (value = '') => {
  if (!value) return ''
  let normalized = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  normalized = normalized.toLowerCase()
  normalized = normalized.replace(/[^a-z0-9]/gi, '')
  return normalized
}

const levenshtein = (a, b) => {
  const lenA = a.length
  const lenB = b.length
  if (lenA === 0) return lenB
  if (lenB === 0) return lenA

  const dp = Array.from({ length: lenA + 1 }, () => new Array(lenB + 1).fill(0))
  for (let i = 0; i <= lenA; i++) dp[i][0] = i
  for (let j = 0; j <= lenB; j++) dp[0][j] = j

  for (let i = 1; i <= lenA; i++) {
    for (let j = 1; j <= lenB; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1
      dp[i][j] = Math.min(
        dp[i - 1][j] + 1, // deletion
        dp[i][j - 1] + 1, // insertion
        dp[i - 1][j - 1] + cost // substitution
      )
    }
  }
  return dp[lenA][lenB]
}

export const buildBrandSuggestions = (candidate, existingBrands = []) => {
  const normalizedCandidate = normalizeBrand(candidate)
  if (!normalizedCandidate) return []

  const suggestions = existingBrands.filter((brand) => {
    const norm = normalizeBrand(brand)
    if (!norm || brand === candidate) return false
    if (norm === normalizedCandidate) return true
    return levenshtein(norm, normalizedCandidate) <= 2
  })

  return Array.from(new Set(suggestions))
}
